import React from 'react';
import { Facebook, Instagram } from 'lucide-react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const socialLinks = [
    {
      name: 'Instagram',
      icon: Instagram,
      href: 'https://www.instagram.com/unotsu1973/',
      color: 'text-pink-600 hover:text-pink-800'
    },
    {
      name: 'Facebook',
      icon: Facebook,
      href: 'https://www.facebook.com/profile.php?id=100027572019849',
      color: 'text-blue-600 hover:text-blue-800'
    }
  ];

  return (
    <footer className="bg-white" style={{ color: '#e3628d' }}>
      {/* Social Media Section */}
      <div className="bg-gray-100 py-8">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <h3 className="text-xl font-bold mb-6" style={{ color: '#e3628d' }}>うのつのぶこ 公式アカウント</h3>
            <div className="flex justify-center space-x-6">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  className="transition-colors duration-200"
                  style={{ color: '#e3628d' }}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#d1557e'}
                  onMouseLeave={(e) => e.currentTarget.style.color = '#e3628d'}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`うのつのぶこ ${social.name}（外部サイト）`}
                >
                  <social.icon size={24} aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="bg-white py-8">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Left Column - Site Info */}
            <div className="text-center">
              <div className="mb-4">
                <h4 className="text-xl font-bold mb-3" style={{ color: '#e3628d' }}>うのつのぶこ</h4>
                <p className="text-gray-600 text-sm mt-1">弁士/編集・ライター歴27年</p>
                <p className="text-gray-600 text-sm">「玉川つばめ通信」主宰</p>
              </div>
            </div>

            {/* Right Column - Links */}
            <div className="text-center">
              <h4 className="text-lg font-bold mb-4" style={{ color: '#e3628d' }}>サイトマップ</h4>
              <ul className="space-y-2">
                <li>
                  <a href="/" className="text-gray-800 hover:text-gray-600 transition-colors duration-200">
                    ホーム
                  </a>
                </li>
                <li>
                  <a href="/profile-detail" className="text-gray-800 hover:text-gray-600 transition-colors duration-200">
                    プロフィール
                  </a>
                </li>
                <li>
                  <a href="/activities-detail" className="text-gray-800 hover:text-gray-600 transition-colors duration-200">
                    活動報告
                  </a>
                </li>
                <li>
                  <a href="/contact-detail" className="text-gray-800 hover:text-gray-600 transition-colors duration-200">
                    お問い合わせ
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="bg-gray-100 py-4">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <p className="text-sm" style={{ color: '#e3628d' }}>
              Copyright {currentYear} © うのつのぶこ, All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 